import React from 'react'
import { ModalBody, Form, FormGroup, Label, Input } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import ErrorBoundary from '@/components/ErrorBoundary'
import { ValidationBoundary, ValidationState, Validator } from '@/components/validation'
import Resx from '@/components/Resx'
import context from '@/context'
import { allowErrorDialog } from '@/utils/fetch'
import { dialogTypes } from '@/dialogs/index'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import { ServerErrorViewer } from '@/components/validation/serverErrorViewer'
import { useDebouncedEffect } from '@/hooks/useDebouncedEffect'

const InputPassphraseDialog = (props) => {
  const [ passphrase, setPassphrase ] = React.useState('')
  const [ passphraseAgain, setPassphraseAgain ] = React.useState('')
  const [ customError, setCustomCustomError ] = React.useState({})
  const [ error ] = React.useState(props.error)

  useDebouncedEffect(() => {
    if (passphrase || passphraseAgain) {
      validatePasswordByPolicy()
    }
  }, [ passphrase, passphraseAgain ], 300)

  const validatePasswordByPolicy = (successEvent) => {
    let errors = []

    if (passphrase !== passphraseAgain) {
      errors.push({ localizedMessage: props.localize('Security.PassphrasesDiffer') })
    }

    context.api.cryptoService.validateRsaKeys({ passphrase }, allowErrorDialog)
      .then(response => {
        if (!response.success || errors.length !== 0) {
          errors.push(...response.validationErrors)
          setCustomCustomError({ validationErrors: errors })
        } else {
          setCustomCustomError({ validationErrors: errors })
          if (typeof successEvent === 'function') {
            successEvent()
          }
        }
      })
      .catch(err => {
        this.props.openDialog({
          dialogType: dialogTypes.alert,
          title: 'Common.Error',
          localizedContent: err
        })
      })
  }

  const handleSaveClick = () => {
    validatePasswordByPolicy(() => props.onAction(passphrase))
  }

  return (
    <ValidationBoundary serverError={error}>
      <BasicHeader title='Security.Passphrase' {...props} />
      <ModalBody>
        <ErrorBoundary>
          <Form>
            <h5>{ props.localize('Security.EnterPassphraseForEncryption') }</h5>
            <FormGroup>
              <Label>{ props.localize('Security.Passphrase') }</Label>
              <Validator name='passphrase' value={passphrase} required>
                <Input id='passphrase' type='password' onChange={(e) => setPassphrase(e.target.value)}
                  value={passphrase} />
              </Validator>
            </FormGroup>
            <FormGroup>
              <Label>{ props.localize('Security.PassphraseAgain') }</Label>
              <Validator name='passphraseAgain' value={passphraseAgain} required>
                <Input id='passphraseAgain' type='password'
                  onChange={(e) => setPassphraseAgain(e.target.value)}
                  value={passphraseAgain} />
              </Validator>
            </FormGroup>
          </Form>
          <Resx name='Security.DownloadRsaKeyInfo' />
        </ErrorBoundary>
      </ModalBody>

      <ValidationState render={({ isValid, serverError }) =>
        <React.Fragment>
          <ServerErrorViewer error={customError || serverError} showErrorMessage />
          <div className='text-right'>
            <ConfirmFooter primaryButtonText='Common.SaveAndClose' icon='save' {...props}
              onAction={handleSaveClick} disabled={!isValid} />
          </div>
        </React.Fragment>
      } />
    </ValidationBoundary>
  )
}

export default {
  component: InputPassphraseDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/inputPassphrase.js